// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-popover {
  --width: 300px;
}

::ng-deep ion-button::part(native):hover {
  opacity: 1;
}
::ng-deep ion-button::part(native):hover .date {
  border-bottom: 1px dashed var(--segmentButtonColor);
}

ion-popover::part(backdrop) {
  background-color: transparent;
  cursor: default;
}

ion-popover::part(content) {
  padding: 0;
  overflow: hidden;
  --border-radius: 5px;
  border: 1px solid var(--mc-color-hr);
  --box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.025), 0 8px 10px 1px rgba(0, 0, 0, 0.025), 0 3px 8px 2px rgba(0, 0, 0, 0.025);
}

ion-select,
ion-label {
  font-size: 14px !important;
}

ion-button.button-solid {
  --box-shadow: none;
  --padding-start: 1rem;
  --padding-end: 1rem;
  --padding-top: 0.5rem;
  --padding-bottom: 0.5rem;
  height: 28px;
  transition: all, 0.3s;
  --border-radius: 5px;
  --background: var(--mc-color-light-grey);
  --color: var(--mc-color-dark-grey);
  --color-activated: var(--ion-color-medium);
  font-weight: 400;
  text-transform: initial;
  font-size: 14px;
  letter-spacing: 0;
  margin-inline-start: 0;
}
ion-button.button-solid:hover {
  opacity: 1;
}

ion-button.button-clear {
  height: 28px;
  transition: all, 0.3s;
  --color: var(--mc-color-dark-grey);
  --color-activated: var(--ion-color-medium);
  font-weight: 400;
  text-transform: initial;
  font-size: 12px;
  --box-shadow: none;
  letter-spacing: 0;
}
ion-button.button-clear:hover {
  opacity: 1;
}

label {
  font-size: 14px;
  margin-bottom: 0.25rem;
  display: block;
}

.date-container {
  padding: 0.5rem 0;
}

.no-hover {
  width: 100%;
}
.no-hover:hover {
  opacity: 1 !important;
  z-index: 40001 !important;
}

.no-hover:has(.is-active) ~ .no-hover {
  visibility: hidden;
}
.no-hover:has(.is-active) ~ .no-hover:hover {
  opacity: 0 !important;
  z-index: -1 !important;
}

.datepicker-container:has(.is-active) {
  height: 340px;
}

#btnDatePopover {
  text-transform: none;
  --color: var(--ion-card-color, var(--ion-item-color, var(--ion-text-color-step-450, #737373)));
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0;
  --background-hover: transparent;
  position: relative;
  height: 32px;
  --padding-start: 0;
  --padding-inline-start: 0;
  padding-right: 0;
  margin: 0;
  --ripple-color: transparent;
}
#btnDatePopover .friendlyName {
  background-color: rgba(0, 171, 106, 0.1);
  color: var(--ion-color-primary);
  font-size: 10px;
  padding: 0.375rem;
  border-radius: 4px;
  margin-left: 0.375rem;
}
#btnDatePopover .friendlyName:empty {
  display: none;
}
#btnDatePopover .date {
  margin-left: 0.25rem;
  transition: all, 0.3s;
  position: relative;
  padding-right: 20px;
}
#btnDatePopover .date:before {
  content: "";
  border-bottom: 1px dashed transparent;
  position: absolute;
  left: 0;
  right: 20px;
  bottom: -1px;
}
#btnDatePopover .date:after {
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  font-family: "icomoon" !important;
  content: "\\e313";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 18px;
  position: absolute;
  top: -3px;
  right: 0;
}
#btnDatePopover .date:empty {
  display: none;
}
#btnDatePopover:hover {
  opacity: 1;
}
#btnDatePopover:hover .date:before {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
}

.date-picker-wrap {
  padding-top: 10px;
  padding-bottom: 10px;
  width: 100%;
}
.date-picker-wrap ::ng-deep duet-date-picker .duet-date__input {
  padding: 12px 60px 12px 10px;
  font-size: 14px;
}
.date-picker-wrap ::ng-deep duet-date-picker .duet-date__toggle-icon {
  transform: scale(0.8);
}
.date-picker-wrap ::ng-deep duet-date-picker .duet-date__dialog {
  position: fixed;
  bottom: 0;
  right: 0;
  top: 0;
  margin: 0;
  min-width: 0;
  transform: translateZ(0);
  transform-origin: bottom center;
}
.date-picker-wrap ::ng-deep duet-date-picker .duet-date__dialog .duet-date__dialog-content {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0;
  min-height: 0;
}
.date-picker-wrap ::ng-deep .duet-date__dialog.is-active > .no-hover {
  visibility: hidden;
}

::ng-deep .popover-viewport {
  --ripple-color: transparent;
}
::ng-deep .popover-viewport ion-item:hover:hover,
::ng-deep .popover-interactive ion-item:hover:hover,
::ng-deep .popover-nested ion-item:hover:hover {
  opacity: 1;
  background-color: var(--mc-surface-0);
  --background-hover: var(--mc-surface-0);
}

@media screen and (min-width: 552px) {
  #btnDatePopover {
    padding-right: 0.25rem;
    margin: 0;
  }
}
@media screen and (min-width: 768px) {
  .datepicker-container:has(.is-active) {
    height: 280px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/time-period-picker/time-period-picker.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,UAAA;AACF;AACE;EACE,mDAAA;AACJ;;AAGA;EACE,6BAAA;EACA,eAAA;AAAF;;AAGA;EACE,UAAA;EACA,gBAAA;EACA,oBAAA;EACA,oCAAA;EACA,0HAAA;AAAF;;AAGA;;EAEE,0BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,wCAAA;EACA,kCAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAAF;AAEE;EACE,UAAA;AAAJ;;AAIA;EACE,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AADF;AAGE;EACE,UAAA;AADJ;;AAKA;EACE,eAAA;EACA,sBAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EACE,WAAA;AAFF;AAIE;EACE,qBAAA;EACA,yBAAA;AAFJ;;AAMA;EACE,kBAAA;AAHF;AAKE;EACE,qBAAA;EACA,sBAAA;AAHJ;;AAQE;EACE,aAAA;AALJ;;AASA;EACE,oBAAA;EACA,8FAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;EACA,2BAAA;AANF;AAQE;EACE,wCAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;AANJ;AAOI;EACE,aAAA;AALN;AASE;EACE,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AAPJ;AASI;EACE,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAPN;AAUI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AARN;AAWI;EACE,aAAA;AATN;AAaE;EACE,UAAA;AAXJ;AAcM;EACE,6CAAA;AAZR;;AAkBA;EACE,iBAAA;EACA,oBAAA;EACA,WAAA;AAfF;AAkBI;EACE,4BAAA;EACA,eAAA;AAhBN;AAmBI;EACE,qBAAA;AAjBN;AAoBI;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,wBAAA;EACA,+BAAA;AAlBN;AAoBM;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,aAAA;AAlBR;AAwBE;EACE,kBAAA;AAtBJ;;AA2BE;EACE,2BAAA;AAxBJ;AA2BE;;;EAGE,UAAA;EACA,qCAAA;EACA,uCAAA;AAzBJ;;AA6BA;EACE;IACE,sBAAA;IACA,SAAA;EA1BF;AACF;AA6BA;EAEI;IACE,aAAA;EA5BJ;AACF","sourcesContent":["ion-popover {\r\n  --width: 300px;\r\n}\r\n\r\n::ng-deep ion-button::part(native):hover {\r\n  opacity: 1;\r\n\r\n  .date {\r\n    border-bottom: 1px dashed var(--segmentButtonColor);\r\n  }\r\n}\r\n\r\nion-popover::part(backdrop) {\r\n  background-color: transparent;\r\n  cursor: default;\r\n}\r\n\r\nion-popover::part(content) {\r\n  padding: 0;\r\n  overflow: hidden;\r\n  --border-radius: 5px;\r\n  border: 1px solid var(--mc-color-hr);\r\n  --box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.025), 0 8px 10px 1px rgba(0, 0, 0, 0.025), 0 3px 8px 2px rgba(0, 0, 0, 0.025);\r\n}\r\n\r\nion-select,\r\nion-label {\r\n  font-size: 14px !important;\r\n}\r\n\r\nion-button.button-solid {\r\n  --box-shadow: none;\r\n  --padding-start: 1rem;\r\n  --padding-end: 1rem;\r\n  --padding-top: 0.5rem;\r\n  --padding-bottom: 0.5rem;\r\n  height: 28px;\r\n  transition: all, 0.3s;\r\n  --border-radius: 5px;\r\n  --background: var(--mc-color-light-grey);\r\n  --color: var(--mc-color-dark-grey);\r\n  --color-activated: var(--ion-color-medium);\r\n  font-weight: 400;\r\n  text-transform: initial;\r\n  font-size: 14px;\r\n  letter-spacing: 0;\r\n  margin-inline-start: 0;\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\nion-button.button-clear {\r\n  height: 28px;\r\n  transition: all, 0.3s;\r\n  --color: var(--mc-color-dark-grey);\r\n  --color-activated: var(--ion-color-medium);\r\n  font-weight: 400;\r\n  text-transform: initial;\r\n  font-size: 12px;\r\n  --box-shadow: none;\r\n  letter-spacing: 0;\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\nlabel {\r\n  font-size: 14px;\r\n  margin-bottom: 0.25rem;\r\n  display: block;\r\n}\r\n\r\n.date-container {\r\n  padding: 0.5rem 0;\r\n}\r\n\r\n.no-hover {\r\n  width: 100%;\r\n\r\n  &:hover {\r\n    opacity: 1 !important;\r\n    z-index: 40001 !important\r\n  }\r\n}\r\n\r\n.no-hover:has(.is-active)~.no-hover {\r\n  visibility: hidden;\r\n\r\n  &:hover {\r\n    opacity: 0 !important;\r\n    z-index: -1 !important\r\n  }\r\n}\r\n\r\n.datepicker-container {\r\n  &:has(.is-active) {\r\n    height: 340px;\r\n  }\r\n}\r\n\r\n#btnDatePopover {\r\n  text-transform: none;\r\n  --color: var(--ion-card-color, var(--ion-item-color, var(--ion-text-color-step-450, #737373)));\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  letter-spacing: 0;\r\n  --background-hover: transparent;\r\n  position: relative;\r\n  height: 32px;\r\n  --padding-start: 0;\r\n  --padding-inline-start: 0;\r\n  padding-right: 0;\r\n  margin: 0;\r\n  --ripple-color: transparent;\r\n\r\n  .friendlyName {\r\n    background-color: rgba(0, 171, 106,0.1);\r\n    color: var(--ion-color-primary);\r\n    font-size: 10px;\r\n    padding: 0.375rem;\r\n    border-radius: 4px;\r\n    margin-left: 0.375rem;\r\n    &:empty {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .date {\r\n    margin-left: 0.25rem;\r\n    transition: all, 0.3s;\r\n    position: relative;\r\n    padding-right: 20px;\r\n\r\n    &:before {\r\n      content: '';\r\n      border-bottom: 1px dashed transparent;\r\n      position: absolute;\r\n      left: 0;\r\n      right: 20px;\r\n      bottom: -1px;\r\n    }\r\n\r\n    &:after {\r\n      speak: none;\r\n      font-style: normal;\r\n      font-weight: normal;\r\n      font-variant: normal;\r\n      text-transform: none;\r\n      line-height: 1;\r\n      font-family: \"icomoon\" !important;\r\n      content: \"\\e313\";\r\n      -webkit-font-smoothing: antialiased;\r\n      -moz-osx-font-smoothing: grayscale;\r\n      font-size: 18px;\r\n      position: absolute;\r\n      top: -3px;\r\n      right: 0;\r\n    }\r\n\r\n    &:empty {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n\r\n    .date {\r\n      &:before {\r\n        border-bottom: 1px dashed rgba(0, 0, 0, 0.25);\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.date-picker-wrap {\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  width: 100%;\r\n\r\n  ::ng-deep duet-date-picker {\r\n    .duet-date__input {\r\n      padding: 12px 60px 12px 10px;\r\n      font-size: 14px;\r\n    }\r\n\r\n    .duet-date__toggle-icon {\r\n      transform: scale(0.8);\r\n    }\r\n\r\n    .duet-date__dialog {\r\n      position: fixed;\r\n      bottom: 0;\r\n      right: 0;\r\n      top: 0;\r\n      margin: 0;\r\n      min-width: 0;\r\n      transform: translateZ(0);\r\n      transform-origin: bottom center;\r\n\r\n      .duet-date__dialog-content {\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        right: 0;\r\n        left: 0;\r\n        margin: 0;\r\n        min-height: 0;\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n  ::ng-deep .duet-date__dialog.is-active>.no-hover {\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n::ng-deep {\r\n  .popover-viewport {\r\n    --ripple-color: transparent;\r\n  }\r\n\r\n  .popover-viewport ion-item:hover:hover,\r\n  .popover-interactive ion-item:hover:hover,\r\n  .popover-nested ion-item:hover:hover {\r\n    opacity: 1;\r\n    background-color: var(--mc-surface-0);\r\n    --background-hover: var(--mc-surface-0);\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 552px) {\r\n  #btnDatePopover {\r\n    padding-right: 0.25rem;\r\n    margin: 0;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 768px) {\r\n  .datepicker-container {\r\n    &:has(.is-active) {\r\n      height: 280px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
